module.exports = __webpack_public_path__ + "img/moon.be5030ca.webp";